var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deckgl-container"},[_vm._t("background"),_vm._t("default"),_c('canvas',{ref:"canvas",attrs:{"id":"deck-canvas"},on:{"contextmenu":_vm.handleContextMenu}}),_vm._t("foreground")],2)}
var staticRenderFns = []

export { render, staticRenderFns }